module.exports = __webpack_public_path__ + "jquery.minicolors-44ae4fdb16ba192549377318d3e93784.png";